/**
 * @module documentSize
 * @description A list of documentSize
 */

export const documentSize = ['A5', 'A4', 'A3', 'A2'] as const;
export type DocumentSize = (typeof documentSize)[number];
